import { html, LitElement } from 'lit';
import { shared } from '../styles';
import { connect } from 'pwa-helpers/connect-mixin.js';
import { store } from '../store.js';
import Gauge from 'svg-gauge';
import {
  selectMissionProgress,
  selectQuestDaysRemaining
} from '../selectors/quest.selectors.js';

const styles = (daysRemaining) => html`
  <style>
    ${shared()} :host {
      position: relative; 
    }

    .gauge-container {
      display: block;
    }
    .gauge-container > .gauge > .dial {
      stroke: #eee;
      stroke-width: 7;
    }

    .gauge-container > .gauge .value {
      stroke-width: 7;
    }

    div.days {
      position: absolute;
      top: 5em;
      text-align: center;
      width: 100%;
      color: ${daysRemaining === 0 ? 'var(--app-primary-color)' : 'var(--app-tertiary-color)'}
    }

    div.days .value {
      font-size: var(--font-size-extra-large);
    }

    div.days .label {
      font-size: var(--font-size-medium-small);
      margin-top: -0.8em;
      color: ${daysRemaining === 0 ? 'var(--app-primary-color)' : 'var(--app-tertiary-color)'}
    }
  </style>
`;

class Dial extends connect(store)(LitElement) {
  updated(updatedProperties) {
    if (updatedProperties.has('progress')) {
      if (!this.gauge) {
        this.gauge = Gauge(this.shadowRoot.getElementById('cpuSpeed'), {
          max: 100,
          dialStartAngle: -90,
          dialEndAngle: -90.001,
          // custom label renderer
          label: () => '',
          value: 0,
          // Custom dial colors (Optional)
          color: function(value) {
            if (value < 20) {
              return '#ef4655'; // green
            } else if (value < 40) {
              return '#f7aa38'; // yellow
            } else if (value < 60) {
              return '#fffa50'; // orange
            } else {
              return '#5ee432'; // red
            }
          }
        });
      }

      this.gauge.setValueAnimated(this.progress, 1);
    }
  }
  render() {
    return html`
      ${styles(this.daysRemaining)}

      <div id="cpuSpeed" class="gauge-container">
        <div class="days">
          <div class="value">${this.daysRemaining}</div>
          <div class="label">days left</div>
        </div>
      </div>
    `;
  }

  static get properties() {
    return {
      progress: Number,
      daysRemaining: Number
    };
  }

  stateChanged(state) {
    this.progress = selectMissionProgress(state);
    this.daysRemaining = selectQuestDaysRemaining(state);
  }
}

window.customElements.define('e-dial', Dial);
